var map = {
	"./bottelegram.png": "2eed",
	"./mobileid.png": "1704",
	"./ok.png": "21b5",
	"./rcs.png": "6bcb",
	"./sms.png": "5a5e",
	"./viber.png": "9c45",
	"./vk.png": "7157",
	"./webchat.png": "a07a",
	"./webpush.png": "a3a1",
	"./whatsapp.png": "f7c5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "058e";